import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    asset: 'Asset',
    apy: 'APY',
    myPosition: 'My position',
    actions: 'Actions',
    stakeMore: 'Stake more',
    withdraw: 'Withdraw',
  },
};
